export default __webpack_public_path__ + "static/media/zero-illustration.6ec1b903.svg";